import { useQuery } from '@tanstack/react-query';
import { getFeedData } from 'api/feedApi';
import ghostAnimation from 'assets/img/lottie-animation/ghost.json';
import { titler } from 'helpers/titler';
import Lottie from 'lottie-react';
import Loading from 'pages/components/Loading';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import FeedObject from './FeedObject';

const Feed = () => {
  titler('Attività');
  const {
    data: feed,
    isLoading,
    isError,
    error
  } = useQuery({
    queryKey: ['feedData'],
    queryFn: getFeedData
  });

  if (isError) {
    toast.error(error.message);
    return <Navigate to="/classe" />;
  }

  if (isLoading) {
    return <Loading />;
  }

  const emptyFeedSpan = [
    <span key="0">
      Sembra che questa classe sia un luogo piuttosto tranquillo!
      <br />
      Non ci sono bonus o malus recenti.
    </span>,
    <span key="1">
      È un momento tranquillo in classe.
      <br />
      Nessun bonus o malus aggiunti per il momento!
    </span>,
    <span key="2">
      La lista dei bonus e malus è attualmente vuota.
      <br />
      Forse il capoclasse deve darsi una svegliata!
    </span>,
    <span key="3">Non ci sono bonus o malus recenti da mostrare.</span>,
    <span key="4">
      Al momento non ci sono bonus o malus aggiunti di recente.
    </span>,
    <span key="5">
      Nulla da segnalare per ora, ma la tranquillità precede spesso una
      tempesta!
    </span>,
    <span key="6">
      Abbiamo controllato ovunque: nessun malus o bonus aggiunto!
      <br />
      Forse oggi è giorno di riposo?
    </span>
  ];

  const randomEmptyFeedSpan =
    emptyFeedSpan[Math.floor(Math.random() * emptyFeedSpan.length)];

  const parseDateStringTitle = dateString => {
    // Create Date object
    var feedDayDate = new Date(dateString);
    feedDayDate.setHours(0, 0, 0, 0);

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    // get the difference between today(at 00:00:00) and the date
    var diff = today.getTime() - feedDayDate.getTime();

    if (feedDayDate.getTime() == today.getTime()) {
      return 'Oggi';
    } else if (diff <= 24 * 60 * 60 * 1000) {
      return 'Ieri';
    } else {
      return feedDayDate.toLocaleDateString('it-IT', {
        weekday: 'long',
        month: 'long',
        day: 'numeric'
      });
    }
  };

  if (Object.keys(feed).length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-75 text-center">
        <div className="w-75">
          <Lottie
            animationData={ghostAnimation}
            loop={true}
            style={{ height: '250px' }}
          />
          <h4>{randomEmptyFeedSpan}</h4>
        </div>
      </div>
    );
  }
  return (
    <>
      {Object.keys(feed)
        .toReversed()
        .map(function (date, index) {
          return (
            <>
              <div className="mb-4" key={index}>
                <Card className="mb-2">
                  <Card.Body>
                    <Row>
                      <Col className="text-center">
                        <h5 className="mb-0">{parseDateStringTitle(date)}</h5>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                {feed[date].toReversed().map(function (feedObject, index) {
                  return (
                    <FeedObject
                      name={feedObject.bonmal.name}
                      points={feedObject.bonmal.points}
                      quantity={feedObject.bonmal.quantity}
                      player={feedObject.player}
                      createdAt={feedObject.createdAt}
                      key={index}
                    />
                  );
                })}
              </div>
              {/* <AdSenseComponent
                adClient="ca-pub-2745866654731902"
                adSlot="2813535718"
                adFormat="auto"
              /> */}
            </>
          );
        })}
    </>
  );
};

export default Feed;
